import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    firstInstructionsTime: 100,
    secondInstructionsTime: 2750,
    thirdInstructionsTime: 5150,
    fourthInstructionsTime: 8800,
    includeSpaceBeforePercentSymbol: false
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }

  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.firstInstructionsTime = 100;
      config.secondInstructionsTime = 2250;
      config.thirdInstructionsTime = 4600;
      config.fourthInstructionsTime = 8000;
      config.includeSpaceBeforePercentSymbol = true;
      break;
  }

  return config;
}